export default __webpack_public_path__ + "static/media/SEXUALLY-TRANSMITTED-DISEASES.542b40b8.png";